import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Environment } from 'src/typings';
import { EnvironmentToken } from 'src/util';
import { TalentHappyPathDataService } from "../shared/service/talent-happy-path-data-service";
import { TranslateService } from "@ngx-translate/core";
import {Gather} from "../../gather/gather-typings";
import { Countries } from "../../enums";
import { getJobBoardUrl, NOT_A_FIT } from "../shared/util/talent-happy-path-util";
import { ActivatedRoute } from '@angular/router';

const THP_CONTEXT = 'talent-happy-path.quick-apply';
const GATHER_CONTEXT = 'gather';
const NOT_A_FIT_CONTEXT = 'gather.not-interested';
const WELCOME_TEXT = 'talent-happy-path.welcome-text';
const THANK_YOU_TITLE = 'thank-you-page.title';
const THANK_YOU_MESSAGE = 'thank-you-page.message';
const GENERAL_APPLICATION_THANK_YOU_TITLE = 'thank-you-page.general-application-title';
const GENERAL_APPLICATION_THANK_YOU_MESSAGE = 'thank-you-page.general-application-message';
@Component({
  selector: 'app-thank-you',
  standalone: false,
  templateUrl: './thank-you.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './thank-you.component.scss'
})
export class ThankYouComponent implements OnInit {
  postingInfo: PostingInfo;
  gather: Gather;
  isGather: boolean = false;
  isFromVmsSubmittal: boolean = false;
  isFromNotAFit: boolean = false;
  titleText: string = String(this.translateService.instant(THP_CONTEXT.concat('.').concat(THANK_YOU_TITLE)));
  messageText: string = String(this.translateService.instant(THP_CONTEXT.concat('.').concat(THANK_YOU_MESSAGE)));
  matUrl: string;
  countryId: number;
  aquentWebsite: string;
  constructor(@Inject(EnvironmentToken) private environment: Environment,
              protected talentHappyPathDataService: TalentHappyPathDataService,
              protected translateService: TranslateService,
              private route: ActivatedRoute) {
    this.matUrl = this.environment.matHost;
    this.aquentWebsite = this.environment.aquentWebsite;
    this.postingInfo = this.talentHappyPathDataService.postingInfo;
    if (this.talentHappyPathDataService.isGeneralApplication) {
      this.countryId = this.talentHappyPathDataService.talent.countryId;
    } else {
      this.countryId = this.postingInfo?.countryId;
    }
  }

  ngOnInit() {
    this.isFromVmsSubmittal = this.route.snapshot.queryParamMap.get('from') === 'vms-submittal';
    this.isFromNotAFit = this.route.snapshot.queryParamMap.get('from') === NOT_A_FIT;
    this.postingInfo = this.talentHappyPathDataService.postingInfo;
    this.gather = this.talentHappyPathDataService.gather;
    if (this.isFromNotAFit) {
      this.isGather = true;
      this.setNotAFitThankYouContent();
    } else if (this.gather && this.gather.gatherId) {
      this.isGather = true;
      this.setGatherVmsThankYouContent();
    } else if (this.isFromVmsSubmittal) {
      this.setGatherVmsThankYouContent();
    }
    if (this.talentHappyPathDataService.isGeneralApplication) {
      if (this.countryId === Countries.JP) {
        const generalTitleKey = THP_CONTEXT.concat('.').concat(GENERAL_APPLICATION_THANK_YOU_TITLE);
        const translatedGeneralTitle = String(this.translateService.instant(generalTitleKey));
        this.titleText = translatedGeneralTitle && translatedGeneralTitle !== generalTitleKey
          ? translatedGeneralTitle
          : String(this.translateService.instant(THP_CONTEXT.concat('.').concat(THANK_YOU_TITLE)));
      }
      this.messageText = String(this.translateService.instant(THP_CONTEXT.concat('.').concat(GENERAL_APPLICATION_THANK_YOU_MESSAGE)));
    }
  }

  private setGatherVmsThankYouContent() {
    this.titleText = String(this.translateService.instant(GATHER_CONTEXT.concat('.').concat(THANK_YOU_TITLE)));
    this.messageText = String(this.translateService.instant(GATHER_CONTEXT.concat('.').concat(THANK_YOU_MESSAGE)));
  }

  private setNotAFitThankYouContent() {
    this.titleText = String(this.translateService.instant(NOT_A_FIT_CONTEXT.concat('.').concat(THANK_YOU_TITLE)));
    this.messageText = String(this.translateService.instant(NOT_A_FIT_CONTEXT.concat('.').concat(THANK_YOU_MESSAGE)));
  }

  get headerText(): string {
    if (this.isFromNotAFit) {
      return null;
    }
    return this.postingInfo ? this.postingInfo.jobTitle : WELCOME_TEXT;
  }

  showMessageText() {
    return this.countryId !== Countries.JP;
  }

  navigateToMat() {
    window.location.href = this.matUrl;
  }

  navigateToJobBoard() {
    window.location.href = getJobBoardUrl(this.talentHappyPathDataService.talent?.countryId);
  }

}
